import { render } from "./Votings.vue?vue&type=template&id=b0dbd3ec&scoped=true"
import script from "./Votings.vue?vue&type=script&lang=js"
export * from "./Votings.vue?vue&type=script&lang=js"

import "./Votings.vue?vue&type=style&index=0&id=b0dbd3ec&scoped=true&lang=css"

import exportComponent from "/Users/philippschurig/PhpstormProjects/plenty_analytics_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0dbd3ec"]])

export default __exports__